<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <div class="finance-header">
        <span class="finance-span">
          <label>所属公司:</label>
          <vxe-input
              v-model="accName"
              @keyup.enter.native="search"
              placeholder="请输入所属公司"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>对方账号户名:</label>
          <vxe-input
              v-model="otherAccName"
              @keyup.enter.native="search"
              placeholder="请输入对方账号户名"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>对方账号:</label>
          <vxe-input
              v-model="otherAccNum"
              @keyup.enter.native="search"
              placeholder="请输入账号户名"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>会员名称:</label>
          <vxe-input
              v-model="memName"
              @keyup.enter.native="search"
              placeholder="请输入会员名称"
              style="width: 200px"
          ></vxe-input>
        </span>
      </div>
      <div class="finance-header" style="display: flex">
         <span class="finance-span finance-span-time">
          <label>选择时间:</label>
          <DatePicker
              type="date"
              v-model="startTime"
              placeholder="请选择开始日期"
              style="width: 200px"
          ></DatePicker>
          <i class="line-icon">--</i>
          <DatePicker
              type="date"
              v-model="endTime"
              placeholder="请选择结束日期"
              style="width: 200px"
          ></DatePicker>
        </span>
        <span class="finance-span">
          <Button status="primary" icon="ios-search" @click="search" style="border-radius: 5px;">搜索 </Button>
          <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置 </Button>
          <Button status="primary" v-if="isHavePermission('realaccount:batchDownload')" @click="batchDownload(0)"
                  :style="isHavePermission('realaccount:batchDownload') ? 'margin-left: 10px;border-radius: 5px;':''">批量下载平台回单</Button>
          <Button status="primary" v-if="isHavePermission('realaccount:batchDownloadCeb')"
                  style="margin-left: 10px;border-radius: 5px;">
            <Dropdown
                trigger="click"
                style="  color: #666"
                transfer
            >
            批量下载光大回单
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button
                      class="button-gengduo"
                      @click="batchDownload(1)"
                  >导出pdf格式
                  </Button>
                  <Button
                      class="button-gengduo"
                      @click="batchDownload(1,1)"
                  >导出png格式
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </Button>
        </span>
        <span class="finance-span">
          <label>回单筛选</label>
          <vxe-select
              v-model="searchFile"
              :options="fileOptions"
              style="width: 120px"
          ></vxe-select>
        </span>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="dataList"
          :footer-method="footerMethod"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="60">
        </vxe-table-column>
        <vxe-table-column title="操作" width="60">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" transfer>
              <icon
                  type="text"
                  custom="iconfont icon-gengduo"
                  size="14px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" @click="showPic(row.id, 0)">查看平台回单</Button>
                  <Button class="button-gengduo" @click="showPic(row.id, 1)">查看光大回单</Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="accName" title="所属公司" width="120">
        </vxe-table-column>
        <vxe-table-column field="accNum" width="180" title="账号">
        </vxe-table-column>
        <vxe-table-column field="procTimestamp" width="160" title="时间">
          <template slot-scope="{ row }">
            <span>{{ row.procTimestamp | timeFormatDateTime }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="brief"
            width="150"
            title="摘要"
        ></vxe-table-column>

        <vxe-table-column
            field="reduceAmount"
            width="120"
            title="借方"
        >
          <template slot-scope="{ row }">
            <span v-if="row.addReduce === '1' ">{{ row.tradeAmount | numberToCurrency }}</span>
            <span v-else> -- </span>
          </template>
        </vxe-table-column>

        <vxe-table-column
            field="addAmount"
            width="120"
            title="贷方"
        >
          <template slot-scope="{ row }">
            <span v-if="row.addReduce === '0' ">{{ row.tradeAmount | numberToCurrency }}</span>
            <span v-else> -- </span>
          </template>
        </vxe-table-column>

        <vxe-table-column field="balance" width="120" title="余额">
          <template slot-scope="{ row }">
            <span>{{ row.balance | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="otherAccName" width="200" title="对方账号户名">
        </vxe-table-column>
        <vxe-table-column
            field="otherAccBankName"
            width="200"
            title="对方账号开户行名称"
        >
        </vxe-table-column>
        <vxe-table-column field="otherAccNum" width="180" title="对方账号">
        </vxe-table-column>
        <vxe-table-column
            field="memName"
            width="180"
            title="会员名称"
        ></vxe-table-column>
        <vxe-table-column
            field="memNum"
            width="120"
            title="会员号"
        ></vxe-table-column>
        <vxe-table-column
            field="subAcc"
            width="120"
            title="会员子账号"
        ></vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {fundDetailFooter, hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";
import moment from 'moment'
import {apiPost} from "@/utils/api";
import getAuthOrization from "@/mixin/getAuthOrization";
import viewOrderDetail from "@/mixin/viewOrderDetail";

moment.locale('zh-CN')

export default {
  mixins: [getAuthOrization],
  data() {
    return {
      loading: false,
      dataList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      accName: null,
      otherAccName: null,
      otherAccNum: null,
      memName: null,
      startTime: '',
      endTime: '',
      totalAdd: 0,
      totalReduce: 0,
      searchFile: null,
      fileOptions: [{
        label: '全部',
        value: null
      }, {
        label: '有光大回单',
        value: 1
      }, {
        label: '无光大回单',
        value: 0
      },],
    };
  },
  mounted() {
    this.$bus.$on("交易资金汇总", () => {
      this.reset();
      this.startTime = moment().startOf("day").format("YYYY-MM-DD 00:00:00");
      this.endTime = moment().endOf('day').format("YYYY-MM-DD 23:59:59");
    });
    this.startTime = moment().startOf("day").format("YYYY-MM-DD 00:00:00"),
        this.endTime = moment().endOf('day').format("YYYY-MM-DD 23:59:59")
  },
  methods: {
    reset() {
      this.accName = null;
      this.otherAccName = null;
      this.otherAccNum = null;
      this.memName = null;
      this.startTime = '';
      this.endTime = '';
      this.page.currentPage = 1;
      this.dataList = []
      this.searchFile = null;
    },
    search() {
      this.page.pageSize = 100000;
      if (this.endTime === '' && this.startTime === '' && !this.accName && !this.otherAccName && !this.otherAccNum && !this.memName) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return
      }
      let searchObj = {};
      this.page.currentPage = 1;
      searchObj.accName = this.accName;
      searchObj.otherAccName = this.otherAccName;
      searchObj.otherAccNum = this.otherAccNum;
      searchObj.memName = this.memName;
      searchObj.startTime = this.startTime === '' ? this.startTime : this.$utils.timestamp(this.startTime);
      searchObj.endTime = this.endTime === '' ? this.endTime : (this.$utils.timestamp(this.endTime) + 86399000);
      searchObj.isHavFile = this.searchFile;
      this.getTradeList(searchObj);
    },
    refresh() {
      this.getTradeList()
    },
    footerMethod({columns, data}) {
      return fundDetailFooter({columns, data})
    },
    handlePageChange() {
      this.getTradeList();
    },
    getTradeList(paramsObj = {}) {
      let obj = {};
      obj.page = this.page.currentPage;
      obj.rows = this.page.pageSize;
      obj.orderBy = 2;
      this.loading = true;
      let newObj = Object.assign(obj, paramsObj);
      this.paramsObj = newObj
      $api.finance.queryRealAccFundDetailListModel
          .POST({
            data: newObj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.totalAdd = 0
              this.totalReduce = 0
              this.dataList = res.data.rows;
              this.dataList.forEach(item => {
                if (item.addReduce == 0) {
                  item.addAmount = item.tradeAmount
                } else {
                  item.reduceAmount = item.tradeAmount
                }
              })
              this.totalReduce = parseFloat(this.totalReduce).toFixed(2)
              this.totalAdd = parseFloat(this.totalAdd).toFixed(2)
              this.page.totalResult = res.data.total;
              this.loading = false;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
    },
    async batchDownload(sourceType, exportToPng) {
      if (isEmpty(this.dataList)) {
        this.$XModal.message("请先搜索数据");
        return;
      }
      let that = this;
      let params = this.paramsObj;
      params.sourceType = sourceType
      params.exportToPng = exportToPng
      showLoading();
      let res = postBlob('/api/finance/cebTradeExport/exportFundDetailImage', params)
      hideLoading();
      await saveBlob(".zip", res.data)
    },
    async showPic(id, source) {
      let res = await apiPost("api/finance", "/cebFile/findReceiptFile", {id, source})
      if (res.data && res.data.length > 0) {
        let fileRes = await apiPost("api/tool", "/oss/getUrlListPost", [res.data[0].fileUuid])
        window.open(fileRes[0].url);
      } else {
        this.$XModal.alert({
          message: '暂无回单信息',
          status: "error",
        });
      }
    },
    async showPic2222() {
      let res = await apiPost("api/finance", "/cebFile/getVoucherFileNew", {})
    },
  },
};
</script>

<style>
.finance-header .finance-span {
  display: inline-block;
  padding-right: 10px;
  margin-bottom: 10px;
}

.finance-span-time .line-icon {
  display: inline-block;
  width: 52px;
  text-align: center;
}

.finance-header label {
  display: inline-block;
  padding: 0 5px;
  color: #999;
}

.finance-header .vxe-input--inner,
.finance-header .ivu-input,
.finance-header .ivu-select-selection {
  border-radius: 0;
  border: 1px solid #dcdee2;
  height: 34px;
  box-sizing: border-box;
}

.finance-header .ivu-select {
  width: 320px;
  height: 34px;
  overflow: hidden;
}

.finance-header .ivu-select-multiple .ivu-tag,
.finance-header .ivu-select-input {
  display: inline-block;
  float: left;
}

.finance-header .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  max-height: 32px;
  border-radius: 0;
}

.finance-header .ivu-select-prefix i {
  vertical-align: middle;
  position: absolute;
  right: 8px;
  top: 8px;
}

.ceb-sel-link {
  display: block;
  width: 100%;
  height: 34px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 0.6em;
}
</style>
